// Changing values affects the rendering in drawer
export const CANVAS_MODES = ['off', 'noise', 'block'] as const;
export type CanvasModesType = typeof CANVAS_MODES[number];

export interface ICanvas {
  mode: CanvasModesType;
  noise?: number;
}
